import React from 'react';

import { type DetailsPageRightSidebarProps } from 'app/main/components/page-layouts';

import CommercialCampaignsDetailsSectionStats from './sidebar/CommercialCampaignsDetailsSectionStats';
import CommercialCampaignsDetailsSectionMap from './sidebar/CommercialCampaignsDetailsSectionMap';

export default function CommercialCampaignsDetailsRightSidebar(props: DetailsPageRightSidebarProps) {
	const sections: React.ReactNode[] = [];

	if (!props.isAdd) {
		if (props.model.cmcp_stats) {
			sections.push(<CommercialCampaignsDetailsSectionStats stats={props.model.cmcp_stats} />);
		}
		if (props.model.cmcp_uid) {
			sections.push(<CommercialCampaignsDetailsSectionMap cmcpUid={props.model.cmcp_uid} />);
		}
	}

	return sections;
}
